import { PriceDocumentInterface } from '../../../../../common/types/interfaces'
import { Item } from '../item/Item'

import classes from './List.module.sass'

type Props = {
  list: PriceDocumentInterface[]
  loading: boolean
  showDetails: (el: PriceDocumentInterface) => void
  startEdit: (el: PriceDocumentInterface) => void
}

export const List = ({ list, loading, showDetails, startEdit }: Props) => {
  return (
    <div className={classes.container}>
      {!list?.length && !loading ? (
        <div className={classes.Message}>Нет документов</div>
      ) : (
        list.map((el) => (
          <Item showDetails={showDetails} el={el} startEdit={startEdit} key={el.id} />
        ))
      )}
    </div>
  )
}
